// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YHfLW","title":"Header_title__N7010","side":"Header_side__2XW46"};